import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/corporate/_type';

export default [{
	path: '/home/individual/profile',
	name: 'individualProfile',
	redirect: { name: 'individualProfileEdit' },
	meta: {
		title: 'Kurumsal İnternet Şube - Profil',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "individualProfile" */ '@/views/individual/profile/Home.vue'),
	children: [
		{
			path: 'me',
			name: 'individualProfileEdit',
			meta: {
				title: 'Kişisel Bilgiler',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "individualProfile" */ '@/views/individual/profile/me/Home.vue'),
		}
	]
},
// {
// 	path: '/home/individual/profile/me/phone',
// 	name: 'individualProfileMePhone',
// 	meta: {
// 		title: 'Kurumsal İnternet Şube - Profil',
// 		layout: 'default'
// 	},
// 	beforeEnter: multiguard([checkAuth, checkBankType]),
// 	component: () => import(/* webpackChunkName: "individualProfile" */ '@/views/individual/profile/me/Phone.vue'),
// },
// {
// 	path: '/home/individual/profile/me/mail',
// 	name: 'individualProfileMeMail',
// 	meta: {
// 		title: 'Kurumsal İnternet Şube - Profil',
// 		layout: 'default'
// 	},
// 	beforeEnter: multiguard([checkAuth, checkBankType]),
// 	component: () => import(/* webpackChunkName: "individualProfile" */ '@/views/individual/profile/me/Mail.vue'),
// },
// {
// 	path: '/home/individual/profile/me/name',
// 	name: 'individualProfileMeName',
// 	meta: {
// 		title: 'Kurumsal İnternet Şube - Profil',
// 		layout: 'default'
// 	},
// 	beforeEnter: multiguard([checkAuth, checkBankType]),
// 	component: () => import(/* webpackChunkName: "individualProfile" */ '@/views/individual/profile/me/Name.vue'),
// },
]